export const unmaskFieldDate = (dateString: string) => {
  if (!dateString) return '';
  const [day, month, year] = dateString.split('/');
  return new Date(+year, +month - 1, +day, 0, 0, 0, 0).toISOString();
};

export const maskFieldDate = (dateString: string) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString('pt-BR').split(',')[0];
};
